import React from "react";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Wizard from "components/Wizard/Wizard.js";

import { TestContext } from "contexts/TestContext.js";
import PdfBasedTestConfig from "./PdfBasedTestWizardSteps/PdfBasedTestConfig.js";
import TestPdfSectionMapping from "./PdfBasedTestWizardSteps/TestPdfSectionMapping.js";

import CustomAlert from "components/CustomAlert/CustomAlert.js";

import useCreatePool from "hooks/poolHooks/useCreatePool.js";
import useUpdateTest from "hooks/testsHooks/useUpdateTest.js";

import useCreatePdfBasedTest from "hooks/testsHooks/useCreatePdfBasedTest.js";
import { withRouter } from "react-router";
import activateService from "services/TestService/activateService.js";

function PdfBasedTestWizard(props) {

    const { mutate: createDefaultPool } = useCreatePool();

    let state = null;
    if (props.location && props.location.state) {
        state = props.location.state.state;
    }
    const { data: response, mutate: createTest, isError } = useCreatePdfBasedTest();
    const { mutate: updateTest } = useUpdateTest();
    console.log("data ", response)

    let id = response && response.data.testId;

    const [testId, setTestId] = React.useState(state ? state.testId : null);
    const [testName, setTestName] = React.useState(state ? state?.text : null);
    const [details, setDetails] = React.useState({ ...state });

    const [flag, setFlag] = React.useState(false);
    const [showAlert, setShowAlert] = React.useState(null);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        console.log("id ", id);
        if (id) {
            setTestId(id);
            createDefaultPool({
                testId: id,
                testCode: details.testCode,
                poolName: details.text,
                choices: 4,
                questionType: "2",
                choiceFormat: 2
            });
        }
    }, [id]);

    const onNextClick = async (data) => {
        let mergedData = { ...details, ...data };

        if (data.type && data.type === "details" &&
            data?.testCodeState == "success" &&
            data?.textState == "success" &&
            data?.durationState == "success" &&
            data?.pointsState == "success"
        ) {
            if (!testId) {
                if (data?.text) setTestName(data?.text);
                createTest(mergedData);
            } else {
                mergedData.testId = testId;
                updateTest(mergedData);
            }
        } else if (data.type && data.type === "pdfSection") {

        }


        setDetails(mergedData);
    };

    const activateTest = async (data) => {

        console.log("final data", data);
        setLoading(true);
        let resp = await activateService.activateTestService(testId);

        if (resp.status == 200) {
            setShowAlert(
                <CustomAlert
                    open={true}
                    openFlag={() => setFlag(!flag)}
                    severity="success"
                    alertMessage={resp?.messege}
                />
            );
            setTimeout(() => {
                props.history.push("/admin/testhome");
            }, 2000);
        } else {
            setShowAlert(
                <CustomAlert
                    open={true}
                    openFlag={() => setFlag(!flag)}
                    severity="error"
                    alertMessage={resp?.messege || "Error occurred."}
                />
            );
        }
        setLoading(false);
    };

    return (
        <TestContext.Provider value={{ testId }}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                    <Wizard
                        validate
                        steps={[
                            {
                                stepName: "Information",
                                stepComponent: PdfBasedTestConfig,
                                stepId: "details",
                                st: { ...state, testId }
                            },
                            {
                                stepName: "PDF Questions",
                                stepComponent: TestPdfSectionMapping,
                                stepId: "pdfStep",
                                st: { ...state, testId }
                            }
                        ]}
                        title={testId ? `Update Test : ${testName}` : "New PDF Test"}
                        subtitle=""
                        finishButtonClick={activateTest}
                        onNextClick={onNextClick}
                        finishButtonText={loading ? "Saving..." : "Save"}
                        isLoading={loading}
                        routeKey="testhome"
                    />
                </GridItem>
                {showAlert}
            </GridContainer>
        </TestContext.Provider>
    );
}

export default withRouter(PdfBasedTestWizard);